import {Component, Input} from '@angular/core';
import {BadgeComponent} from "../../common/badge/badge.component";


@Component({
    selector: 'app-color-contrast',
    templateUrl: './color-contrast.component.html',
    imports: [
    BadgeComponent
],
    styleUrls: ['./color-contrast.component.css']
})
export class ColorContrastComponent {

  privColor1: any = [0, 0, 0];
  privColor2: any = [0, 0, 0];

  contrast = 0;

  @Input()
  set color1(val: any) {
    this.privColor1 = this.hexToRgb(val);
    this.contrast = this.calcContrast(this.privColor1, this.privColor2).toFixed(2);
  }

  @Input()
  set color2(val: any) {
    this.privColor2 = this.hexToRgb(val);
    this.contrast = this.calcContrast(this.privColor1, this.privColor2).toFixed(2);
  }

  hexToRgb(hex): any {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16),
    ] : null;
  }

  luminance(r, g, b): any {
    const a = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
  }

  calcContrast(rgb1, rgb2): any {
    const lum1 = this.luminance(rgb1[0], rgb1[1], rgb1[2]);
    const lum2 = this.luminance(rgb2[0], rgb2[1], rgb2[2]);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05)
      / (darkest + 0.05);
  }

}
